import { makeAutoObservable, runInAction } from "mobx";

import type { AuthService, SignedInUser } from "@mr-portfolio-infrastructure/auth/auth-service";

export type AuthStatus = "checking" | "signedIn" | "redirecting";

/** The signed-in user. Every screen except the sign-in callback requires one. */
export class AuthStore {
  public status: AuthStatus = "checking";
  public user: SignedInUser | null = null;

  private readonly authService: AuthService;

  public constructor(authService: AuthService) {
    this.authService = authService;
    makeAutoObservable(this);
  }

  public get isSignedIn(): boolean {
    const isSignedIn = this.status === "signedIn";

    return isSignedIn;
  }

  public async ensureSignedIn(returnPath: string): Promise<void> {
    const signedInUser = await this.authService.getSignedInUser();

    if (signedInUser !== null) {
      runInAction(() => {
        this.user = signedInUser;
        this.status = "signedIn";
      });

      return;
    }

    await this.signIn(returnPath);
  }

  public async signIn(returnPath: string): Promise<void> {
    runInAction(() => {
      this.user = null;
      this.status = "redirecting";
    });
    await this.authService.signIn(returnPath);
  }

  public async signOut(): Promise<void> {
    runInAction(() => {
      this.status = "redirecting";
    });
    await this.authService.signOut();
  }
}
